var map = {
	"./ad1.jpg": "d402",
	"./ad2.jpg": "ac1c",
	"./ad3.jpg": "9b82",
	"./avatar1.png": "2b78",
	"./avatar2.png": "a1ac",
	"./avatar3.png": "2678",
	"./avatar4.png": "bbdb",
	"./background.png": "cb54",
	"./badminton.svg": "16fa",
	"./basketball.svg": "3633",
	"./esport.svg": "9783",
	"./impetus.svg": "e31c",
	"./impetus_logo.png": "076f",
	"./jimmy.jpg": "ff29",
	"./logo.svg": "27f3",
	"./place-holder-avatar.jpg": "2f04",
	"./soccer.svg": "5247",
	"./table-tennis.svg": "b529",
	"./tennis.svg": "ca57",
	"./volleyball.svg": "9fbd",
	"./webicon.ico": "a3d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "95cd";